<template>
  <span>
    <button
      class="button is-rounded is-small is-light tag-button"
      @click="$emit('open-coupon-modal')"
    >
      <span class="money-icon">🎫</span>

      <span>
        &nbsp;&nbsp;
        {{ $tc("dashboard.coupons", coupons.length) }}
      </span>
    </button>
    &nbsp;
  </span>
</template>

<script>
export default {
  props: ["coupons"]
};
</script>

<style scoped>
.tag-button {
  cursor: pointer;
  border: 1px solid #bbbbbb;
}
</style>
